export default {
   name: 'pageNotFound'
}
